import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip } from "antd";
import InputForm from "./InputForm";
import "./Form.css";

const { Item: ItemForm } = Form;
const { Column } = Table;

export default class TipoAnaliseForm extends Component {
  state = {
    registro: {
      ta_idf: 0,
      ta_descricao: '',

      tai_seq: 0,
      tai_descricao: '',
      tai_min: '',
      tai_max: '',
      tai_ordem: 1,
      tai_imp_laudo: true,
      tai_obs: '',
    },

    tai_imp_laudo: true,
    listaItens: [],
    carregandoForm: false,
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        tai_seq: 0,
        tai_descricao: '',
        tai_min: '',
        tai_max: '',
        tai_ordem: 1,
        tai_imp_laudo: true,
        tai_obs: '',
        listaItens: this.props.registroSelecionado.listaItens
      }, () => {
        this.refs.ta_descricao.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onOK = () => {
    if ((!this.state.registro.ta_descricao) || (this.state.registro.ta_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }

    const reg = {
      ta_idf: this.state.registro.ta_idf,
      ta_descricao: this.state.registro.ta_descricao,
      listaItens: this.state.listaItens,
    }

    this.props.onSalvarClick(reg);
  };



  onAddItem = () => {
    if ((!this.state.registro.tai_descricao) || (this.state.registro.tai_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição do Item' });
      return;
    }

    var seq = 1;
    for (var x in this.state.listaItens) {
      seq = this.state.listaItens[x].tai_seq;
    };

    this.state.listaItens.push({
      tai_seq: seq + 1,
      tai_descricao: this.state.registro.tai_descricao,
      tai_min: this.state.registro.tai_min ? this.state.registro.tai_min : '',
      tai_max: this.state.registro.tai_max ? this.state.registro.tai_max : '',
      tai_ordem: this.state.registro.tai_ordem ? this.state.registro.tai_ordem : 0,
      tai_imp_laudo: this.state.registro.tai_imp_laudo ? 1 : 0,
      tai_obs: this.state.registro.tai_obs ? this.state.registro.tai_obs : '',
    });

    this.setState({
      registro: {
        ...this.state.registro,
        tai_seq: 0,
        tai_descricao: '',
        tai_min: '',
        tai_max: '',
        tai_ordem: 1,
        tai_imp_laudo: true,
        tai_obs: '',
      },
      tai_seq: 0,
      tai_descricao: '',
      tai_min: '',
      tai_max: '',
      tai_ordem: 1,
      tai_imp_laudo: true,
      tai_obs: '',
      listaItens: this.state.listaItens
    });
  };

  onExcluirItemClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaItens = [...this.state.listaItens];
        const index = listaItens.findIndex(registro => registro.tai_item === reg.tai_item && registro.tai_seq === reg.tai_seq);
        listaItens.splice(index, 1);
        this.setState({
          listaItens,
        });
      }
    })
  }

  renderAcoesProdutos = (registro) => {
    return (
      <Tooltip title="Excluir" placement="top">
        <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirItemClick(registro)} icon="delete" />
      </Tooltip>
    );
  };




  renderFlag = (flag) => {
    if (flag) {
      return (
        <span>SIM</span >
      )
    } else {
      return (
        <span>NÂO</span >
      )
    }
  }



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { ta_idf, ta_descricao, tai_seq, tai_descricao, tai_min, tai_max, tai_ordem, tai_imp_laudo, tai_obs } = this.state.registro;
    const { carregandoForm, listaItens } = this.state;

    // console.log('TipoAnaliseForm: ', this.state)

    return (
      <Modal
        title={ta_idf ? "Edição de Tipo de Análise" : "Cadastro de Tipo de Análise"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row style={{ marginBottom: 20 }} >
            <Col xs={24} className="camposEspacoDireita">
              <span>Descrição</span>
              <InputForm
                id="ta_descricao"
                ref="ta_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={ta_descricao}
                validator={value => Boolean(value)}
              />
            </Col>

            <div style={{}}>

              <Col xs={24}>
                <div className="div-subTitulo">
                  <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                    Itens da Análise
                  </span>
                </div>

                <Col xs={19}>
                  <span>Descrição do Item</span>
                  <InputForm
                    id="tai_descricao"
                    ref="tai_descricao"
                    maxLength={60}
                    onChange={this.onChange}
                    value={tai_descricao}
                    validator={value => Boolean(value)}
                  />
                </Col>
                <Col xs={24} sm={5} style={{ marginTop: 20, paddingLeft: 10 }}>
                  <InputForm
                    type="checkbox"
                    id="tai_imp_laudo"
                    ref="tai_imp_laudo"
                    onChange={this.onChange}
                    value={tai_imp_laudo}
                  >
                    Imprimir no Laudo
                  </InputForm>
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Ordenação</span>
                  <InputForm
                    id="tai_ordem"
                    ref="tai_ordem"
                    maxLength={3}
                    onChange={this.onChange}
                    value={tai_ordem}
                    validator={value => Boolean(value)}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Mínimo</span>
                  <InputForm
                    id="tai_min"
                    ref="tai_min"
                    maxLength={20}
                    onChange={this.onChange}
                    value={tai_min}
                    validator={value => Boolean(value)}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Máximo</span>
                  <InputForm
                    id="tai_max"
                    ref="tai_max"
                    maxLength={20}
                    onChange={this.onChange}
                    value={tai_max}
                    validator={value => Boolean(value)}
                  />
                </Col>
                <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                  <span>Observação</span>
                  <InputForm
                    id="tai_obs"
                    ref="tai_obs"
                    maxLength={100}
                    onChange={this.onChange}
                    value={tai_obs}
                    validator={value => Boolean(value)}
                  />
                </Col>


                <Col xs={24} style={{ marginTop: -20 }}>
                  <Button
                    htmlType="button"
                    onClick={this.onAddItem}
                    icon="plus"
                    className="botoesModalForm2x"
                  > Adicionar
                  </Button>
                </Col>
              </Col>

              <Col xs={24} style={{ marginTop: 25 }}>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaItens}
                  pagination={false}
                  rowKey={(listaItens => listaItens.tai_idf + '_' + listaItens.tai_seq)}
                >
                  <Column
                    key="tai_ordem"
                    dataIndex="tai_ordem"
                    title="Ordem"
                    width={"8%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_descricao"
                    dataIndex="tai_descricao"
                    title="Descrição do Item"
                    width={"30%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_min"
                    dataIndex="tai_min"
                    title="Mínimo"
                    width={"8%"}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_max"
                    dataIndex="tai_max"
                    title="Máximo"
                    width={"8%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_imp_laudo"
                    dataIndex="tai_imp_laudo"
                    title="Imp Laudo"
                    render={this.renderFlag}
                    width={"10%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="tai_obs"
                    dataIndex="tai_obs"
                    title="OBS"
                    width={"20%"}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesProdutos}
                    width={"20%"}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </Col>

            </div>

          </Row>


          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TipoAnaliseForm.js